import { Bolt, LogOut, User } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../features/userSlice";
import { useDispatch } from "react-redux";
import { useAuthorization } from "../../hooks/useAuthorization";

const AppNavMenu = ({ user, color, setOpens }) => {
  const menuRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { isAuthorized } = useAuthorization();

  const handleNavOpen = () => {
    setOpen(!open);
    setOpens(false);
  };

  //Handle Click outside the open menu
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  //Logout
  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div ref={menuRef} className={`flex-1 relative`}>
        {Object.keys(user).length > 0 && (
          <button
            onClick={handleNavOpen}
            className={`flex items-center justify-center p-4 w-7 h-7 rounded-full border-2 border-content text-gray-100 ${color} hover:border-2 hover:border-bkg2 `}
          >
            {user?.first_name[0] + user?.last_name[0]}
          </button>
        )}

        {open && (
          <div className="absolute z-10 top-10 right-0 border-2 border-bkg2 whitespace-nowrap rounded-lg text-text-1/70 bg-content flex flex-col justify-center items-center text-left shadow-md px-2 [&_*]:border-b-bkg2 w-44  overflow-hidden ">
            <Link
              to="/profile"
              onClick={(e) => setOpen(false)}
              className="border-b flex-1 w-full flex items-center justify-center gap-x-2 px-3 py-2 "
            >
              <User size={20} /> Profile
            </Link>
            {isAuthorized("settings", "read") && (
              <Link
                to="/settings"
                onClick={(e) => setOpen(false)}
                className="border-b flex-1 w-full flex items-center justify-center gap-x-2 px-3 py-2 "
              >
                <Bolt size={20} /> Settings
              </Link>
            )}
            <button
              onClick={(e) => handleLogout()}
              className="flex-1 w-full flex items-center justify-center gap-x-2 px-3 py-2 "
            >
              <LogOut size={20} /> Logout
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default AppNavMenu;
